import { Icon, IconHelper } from "../common/icon-helper";
import { Txt } from "../common/text";
import { C } from "../common/component";
import { TimerService } from "./timer-service";
import { Tooltip } from "../common/tooltip";

export class TimerButton
{
    private readonly timerButton: JQuery;

    constructor(parent: JQuery)
    {
        this.timerButton =
            C.button.addClass("w-button-primary timer").css({ marginTop: "6px", marginBottom: "6px" })
                .attr("type", "button").appendTo(parent);
        this.setState(false);
        this.timerButton.click(() => TimerService.buttonClicked());
    }

    setState(isStarted: boolean): void
    {
        if (isStarted)
        {
            Tooltip.attach(this.timerButton[0], Txt.stopLogging);
        }
        else
        {
            this.timerButton
                .html(`<span class="${IconHelper.getIconClass(Icon.Play)}"/><span class="mobile"> ${Txt.startLogging}</span>`);
            Tooltip.attach(this.timerButton[0], Txt.startLogging);
        }
    }

    setElapsedTimeText(text: string, isRunning: boolean): void
    {
        this.timerButton.html( `<span class="${IconHelper.getIconClass(isRunning ? Icon.pause : Icon.Play)}"/><span class="timer-text"> ${text}</span>`);
    }
}
